//羽毛球 苏迪曼杯 full
import PlatfromBadmintonCupFullSudirman from '@containers/platfrom_badminton/badmintonCupFull_sudirman.vue'

export default {
  PlatfromBadmintonCupFullSudirman,
}
